/*
  Откуда очередь берёт строки (21.10.2026, требование владельца: «пагинация должна быть
  серверной, а не на фронте»).

  Таблицу и выбор строк рисует `ConveyorQueue`; здесь два источника для неё.

  `ServerQueue` - вся очередь к подаче: страницу просит у сервера (`GET /conveyor/queue`
  с `limit` и `offset`) и получает ещё и общее число. `version` меняется, когда очередь
  могла измениться (после «Собрать реестр» или «Отметить поданными»), и страница
  перечитывается; отметки при этом остаются у `ConveyorQueue`, а прежние строки на
  экране не мигают пустотой, пока идёт запрос.

  `ChosenQueue` - счета, отмеченные в реестре и принесённые кнопкой «В конвейер»
  (16.10.2026). Это перечень, который человек выбрал сам и который сервер уже разобрал
  одним ответом (`POST /conveyor/chosen`): у него нет своей конечной точки со страницами,
  длину задаёт выбор, поэтому листает его панель в браузере (`usePaging`). Строки
  отмечены заранее (`preset`).
*/

import { useCallback } from 'react'

import { api } from '../api/client.js'
import { Loading, Notice } from './Common.jsx'
import ConveyorQueue from './ConveyorQueue.jsx'
import usePagedList from './usePagedList.js'
import usePaging from './usePaging.js'

export function ServerQueue({ version, ...rest }) {
  const load = useCallback((window) => api.conveyorQueue(window), [])
  // `version` перечитывает текущую страницу после действия над очередью.
  const { rows, error, bar } = usePagedList(load, undefined, version)

  if (rows === null) {
    return error ? <Notice error={error} /> : <Loading what="Загружаем очередь" />
  }
  // Сбой перечитывания не уносит очередь вместе с отметками (аудит 26.10.2026, причина 1):
  // плашка стоит над таблицей, а сама таблица остаётся смонтированной.
  return (
    <>
      {error ? <Notice error={error} /> : null}
      {/* «Выбрать весь отбор» - вся очередь с сервера, не больше пятисот (решение владельца 23.10.2026). */}
      <ConveyorQueue {...rest} rows={rows} bar={bar} fetchAll={api.conveyorQueueSelection} />
    </>
  )
}

export function ChosenQueue({ queue, ...rest }) {
  const { rows, bar } = usePaging(queue)
  return <ConveyorQueue {...rest} rows={rows} bar={bar} preset={queue} />
}
